import React, { useState } from "react";
import "../../style/UserDetail.css";
import { getUserDetailsRequest } from "../../../redux/actionDispatcher/admin/userDetailDispatcher";
import { connect, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import dummyProfileImage from "./../../assets/image/dummy-profile-image.png"
import { dealerUrl, imageBaseUrls, webSiteUrl } from "../../../constant/ApiUrls";
import moment from "moment";
import { addBumpSpotlightRequest } from "../../../redux/actionDispatcher/admin/dealerListingDispatcher";
import { toast } from "react-toastify";

const UserDetail = ({ userDetails, getUserDetailsRequest }) => {

  const dispatch = useDispatch();
  const [loadSpotlight, setLoadSpotlight] = useState(false);
  const [loadBump, setLoadBump] = useState(false);

  // const navigate = useNavigate();
  const { id } = useParams(); // Get the ID from the URL
  const userId = id.replace(":", "");
  console.log("User ID:", userId);
  // const dispatch = useDispatch();
  React.useEffect(() => {
    getUserDetailsRequest(userId); // Fetch users only once when the component loads
    // GET_OPENING_HOURS
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);








  const handleSubmit = async (type) => {
    if (type === 1) setLoadBump(true);
    if (type === 2) setLoadSpotlight(true);

    const data = {
      id: userDetails.usersDetails.id,
      type: type,
    };

    try {
      const success = await dispatch(addBumpSpotlightRequest(data)); // ✅ awaits thunk
      if (success) {
        toast.success(type === 1 ? "Bump added successfully!" : "Spotlight added successfully!");
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      console.error("Error adding bump/spotlight:", error);
    } finally {
      if (type === 1) setLoadBump(false);
      if (type === 2) setLoadSpotlight(false);
    }
  };



  return (
    userDetails.loading ?
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-4 mx-auto" style={{ backgroundColor: 'var(--primary-color)' }}></div>
      </div>
      :
      userDetails.usersDetails.vendor_type === 'normal' ? <div className="container">
        {/* User Header */}
        <div className="user-card">
          <div className="user-header" style={{ justifyContent: "center" }}>
            <div className="user-info" style={{ textAlign: "center" }}>

              <div className="user-details" style={{ textAlign: "center" }}>
                <img src={userDetails.usersDetails.image ? `${imageBaseUrls(userDetails.usersDetails.image)}` : dummyProfileImage} alt="Profile" className="user-avatar" style={{ height: "100px", width: "100px", marginBottom: "10px" }} />
                <h2 style={{ marginBottom: "10px" }}>{userDetails.usersDetails.name}</h2>
                <div>
                  <div style={{ padding: "2px 10px", display: "inline-block", backgroundColor: userDetails.usersDetails.status === 1 ? "green" : "red", borderRadius: "10px" }}>

                    <span
                      style={{
                        color: "white",
                        fontWeight: "500",
                        fontSize: "10px",
                      }}
                    >
                      {userDetails.usersDetails.status === 1 ? "Active" : "Blocked"}
                    </span>

                  </div>
                  <div>
                    <button onClick={() => {
                      window.open(`${webSiteUrl}loginasuser/${btoa(userId.toString())}`, '_blank');

                    }
                    } className="btn btn-primary mt-2">Login as <strong>{userDetails.usersDetails.name}</strong></button>
                  </div>
                </div>


              </div>

            </div>

          </div>
        </div>



        {/* Address */}
        <div className="section">
          <div className="user-header">
            <h3>Address</h3>

          </div>
          <div className="info-grid">
            <div className="info-item"><span>Location:</span> {userDetails.usersDetails?.location_name === null ? 'Not Filled' : userDetails.usersDetails?.location_name} </div>

            <div className="info-item"><span>Country:</span> Isle of Man</div>
          </div>
        </div>

        <div className="section">
          <div className="user-header">
            <h3>Other Details</h3>

          </div>

          <div className="info-grid">
            <div className="info-item"><span>Verified Email:</span>&nbsp;{userDetails.usersDetails.email} {userDetails.usersDetails.email_verified === 0 ? <p></p> : <i className="fas fa-check-circle" style={{ color: "var(--primary-color)", fontSize: "12px" }}></i>}</div>

            <div className="info-item"><span>Verified Number:</span>&nbsp;{userDetails.usersDetails.flag ? "+" : ""}{userDetails.usersDetails.flag} {userDetails.usersDetails.number} {userDetails.usersDetails.otp_verified === 0 ? <p></p> : <i className="fas fa-check-circle" style={{ color: "var(--primary-color)", fontSize: "12px" }}></i>}</div>
          </div>
          <div className="info-grid">
            <div className="info-item"><span>Join Date:</span> {moment(userDetails.usersDetails?.created_at).format("DD/MM/YYYY HH:mm:ss")}</div>

            <div className="info-item"><span>Hours Logged In:</span> {userDetails.usersDetails?.hours_logged_in_duration} hrs</div>
          </div>
          <div className="info-grid">
            <div className="info-item"><span>Ads Live:</span> {userDetails.usersDetails?.ads_count || 0}</div>

            <div className="info-item"><span>Save Ads:</span> {userDetails.usersDetails?.saved_ad_count || 0}</div>
          </div>
          <div className="info-grid">
            <div className="info-item"><span>Ads Historically:</span> {userDetails.usersDetails?.total_ads_count || 0}</div>


          </div>
        </div>
      </div>
        :
        userDetails.usersDetails.vendor_type === 'dealer' ? (
          <div className="container dealer-profile">

            {/* Dealer Header */}
            <div className="dealer-profile card shadow-lg p-4">
              <div className="row g-4 align-items-center">
                {/* Left Side - Dealer Image */}
                <div className="col-md-4 text-center">
                  <div className="dealer-avatar-wrapper">
                    <img
                      src={userDetails.usersDetails.image ? `${imageBaseUrls(userDetails.usersDetails.image)}` : dummyProfileImage}
                      alt="Dealer"
                      className="dealer-avatar-lg"
                    />
                    <span
                      className={`status-badge ${userDetails.usersDetails.status === 1 ? "active" : "blocked"
                        }`}
                    >
                      {userDetails.usersDetails.status === 1 ? "Active" : "Blocked"}
                    </span>
                  </div>
                </div>

                {/* Right Side - Dealer Info */}
                <div className="col-md-8">

                  <div>
                    <h2 className="dealer-name mb-1">{userDetails.usersDetails.name}</h2>
                    <h4 className="dealer-business text-primary mb-3">
                      {userDetails.usersDetails.business_name}
                    </h4>



                    <button onClick={() => {
                      window.open(`${dealerUrl}loginasuser/${btoa(userId.toString())}`, '_blank');

                    }
                    } className="btn btn-primary mt-2">Login as <strong>{userDetails.usersDetails.business_name}</strong>
                    </button>




                    <button
                      onClick={() => handleSubmit(2)}
                      className="btn btn-primary mt-2"
                      style={{ marginLeft: "10px", minWidth: "140px" }}
                      disabled={loadSpotlight}
                    >
                      {loadSpotlight ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          &nbsp;Adding...
                        </>
                      ) : (
                        "Add Spotlight"
                      )}
                    </button>

                    {/* Add Bump Button */}
                    <button
                      onClick={() => handleSubmit(1)}
                      className="btn btn-primary mt-2"
                      style={{ marginLeft: "10px", minWidth: "140px" }}
                      disabled={loadBump}
                    >
                      {loadBump ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          &nbsp;Adding...
                        </>
                      ) : (
                        "Add Bump"
                      )}
                    </button>
                  </div>


                  <div className="info-grid">
                    <div className="info-item"><span>Email:</span> {userDetails.usersDetails.email}</div>
                    <div className="info-item"><span>Phone:</span> +{userDetails.usersDetails.flag} {userDetails.usersDetails.number}</div>
                    <div className="info-item"><span>Website:</span> {userDetails.usersDetails.website || "Not Provided"}</div>
                    <div className="info-item"><span>Address:</span> {userDetails.usersDetails.business_address || "Not Provided"}</div>
                    <div className="info-item"><span>Location:</span> {userDetails.usersDetails?.location_name || "Not Filled"}</div>
                    <div className="info-item"><span>About:</span> {userDetails.usersDetails.about || "Not Provided"}</div>

                    {userDetails.usersDetails.new_tier_id && <div className="info-item"><span>Tier:</span> {userDetails.usersDetails?.tier_name || ""}</div>
                    }


                    {userDetails.usersDetails.new_tier_id && (
                      <div className="info-item">
                        <span>Tier Expiry:</span>{" "}
                        {(() => {
                          const expiry = userDetails.usersDetails.tier_expiry;

                          if (!expiry) return "";

                          const expiryDate = new Date(expiry);
                          const now = new Date();

                          // Format date as DD-MM-YYYY
                          const formattedDate = expiryDate.toLocaleDateString("en-GB");

                          const isExpired = expiryDate < now;

                          return (
                            <span style={{ color: isExpired ? "red" : "inherit" }}>
                              {isExpired ? `Expired on ${formattedDate}` : formattedDate}
                            </span>
                          );
                        })()}
                      </div>
                    )}




                    <div className="info-item"><span>Created By:</span> {userDetails.usersDetails?.admin_name || "Not Filled"}</div>
                    <div className="info-item"><span>Updated By:</span> {userDetails.usersDetails?.updated_admin_name || "Not Provided"}</div>

                    <div className="info-item">
                      <span>Created At:</span> {userDetails.usersDetails?.created_at
                        ? new Date(userDetails.usersDetails.created_at).toLocaleDateString("en-GB", {
                          day: "2-digit", month: "2-digit", year: "numeric"
                        })
                        : "Not Filled"}
                    </div>

                    <div className="info-item">
                      <span>Updated At:</span> {userDetails.usersDetails?.updated_at
                        ? new Date(userDetails.usersDetails.updated_at).toLocaleDateString("en-GB", {
                          day: "2-digit", month: "2-digit", year: "numeric"
                        })
                        : "Not Provided"}
                    </div>

                    <div className="info-item"><span>Hours Logged In:</span> {userDetails.usersDetails?.hours_logged_in_duration} hrs</div>


                  </div>
                </div>
              </div>
              {/* <h3 className="section-title">Statistics</h3> */}
              <div className="stats-grid mt-2">
                <div className="stat-card">
                  <h4>{userDetails.usersDetails?.ads_count || 0}</h4>
                  <p>Ads Live</p>
                </div>
                <div className="stat-card">
                  <h4>{userDetails.usersDetails?.saved_ad_count || 0}</h4>
                  <p>Saved Ads</p>
                </div>
                <div className="stat-card">
                  <h4>{userDetails.usersDetails?.recent_ads_count || 0}</h4>
                  <p>Recent Ads</p>
                </div>
                <div className="stat-card">
                  <h4>{moment(userDetails.usersDetails?.created_at).format("DD/MM/YYYY")}</h4>
                  <p>Joined On</p>
                </div>
              </div>
              {(userDetails.usersDetails.opening_hours && <>
                <h3 className="section-title mt-4">Opening Hours</h3>
                <div className="hours-grid">
                  {userDetails.usersDetails.opening_hours.map((hour, index) => (
                    <div key={index} className="hours-item">
                      <strong>{hour.day_of_week}:</strong>{" "}
                      {hour.is_closed ? (
                        <span className="closed">Closed</span>
                      ) : (
                        `${hour.open_time} - ${hour.close_time}`
                      )}
                    </div>
                  ))}
                </div>

              </>)}

            </div>
          </div>
        )

          :
          <div>

          </div>
  );
};



//Getting the state from the store
const mapStateToProps = (state) => {
  return {
    userDetails: state.userDetails,
  };
};

//passing the userData in fetchUsers function and also dispatch method
const mapDispatchToProps = (dispatch) => {
  return {
    getUserDetailsRequest: (data, navigate) => dispatch(getUserDetailsRequest(data, navigate)),
  };
};

//Connecting the component to our store
export default connect(mapStateToProps, mapDispatchToProps)(UserDetail);
